import { HttpInterceptor, HttpRequest, HttpHandler, HttpUserEvent, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

// import 'rxjs/add/operator/do';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/internal/operators/tap';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log(req);
        console.log(req.headers);

        if (req.headers.get('No-Auth') === 'True') {
            return next.handle(req.clone());
        }

        if (localStorage.getItem('userToken') != null) {
            const clonedreq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + localStorage.getItem('userToken'))
            });
            return next.handle(clonedreq)
                .pipe(tap(
                    err => {
                        if (err instanceof HttpErrorResponse) {
                            console.log(err);
                            console.log('req url :: ' + req.url);
                            if (err.status === 401) {
                            this.router.navigate(['user']);
                            }
                        }
                    }
                ));
        } else {
            this.router.navigateByUrl('/login');
        }
    }
}
